export const SUPPORT_PAGE_TAG = 'Atendimento_Geral'
